import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {FormsModule} from '@angular/forms'
import {MarkdownModule} from 'angular2-markdown'
import {UISharedModule} from '../ui-shared/ui-shared.module'
import {FolderRoutingModule} from './folder-routing.module'
import {FolderDashboardComponent} from './folder-dashboard/folder-dashboard.component'
import {FolderViewComponent} from './folder-view/folder-view.component'
import {FolderViewGridComponent} from './folder-view/folder-view-grid/folder-view-grid.component'
import {FolderViewListComponent} from './folder-view/folder-view-list/folder-view-list.component'
import {FolderAddComponent} from './folder-add/folder-add.component'
import {FolderEditComponent} from './folder-edit/folder-edit.component'
import {FolderUploadComponent} from './folder-upload/folder-upload.component'
import {FolderComponent} from './folder.component'
import {FolderViewGridFileitemComponent} from './folder-view/folder-view-grid/folder-view-grid-fileitem/folder-view-grid-fileitem.component'
import {PipeModule} from '../pipe/pipe.module'
import {FolderViewGridFolderitemComponent} from './folder-view/folder-view-grid/folder-view-grid-folderitem/folder-view-grid-folderitem.component'
import {FolderRenameComponent} from './folder-rename/folder-rename.component'
import {FolderVersionComponent} from './folder-version/folder-version.component'
import {FolderViewMobileComponent} from './folder-view/folder-view-mobile/folder-view-mobile.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipeModule,
    UISharedModule,
    FolderRoutingModule,
    MarkdownModule.forRoot(),
  ],
  declarations: [
    FolderDashboardComponent,
    FolderViewComponent,
    FolderViewGridComponent,
    FolderViewListComponent,
    FolderAddComponent,
    FolderEditComponent,
    FolderUploadComponent,
    FolderComponent,
    FolderViewGridFileitemComponent,
    FolderViewGridFolderitemComponent,
    FolderRenameComponent,
    FolderVersionComponent,
    FolderViewMobileComponent,
  ],
  exports: [FolderVersionComponent],
})
export class FolderModule {}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder.module.ts